import {noop} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import StepConfigEditorPane from 'pipelines/generalized-step-config-editor/StepConfigEditorPane';
import {stepIsConfigEditorSupported} from 'pipelines/generalized-step-config-editor/stepTypeIsConfigEditorSupported';
import {PipelineStep} from 'pipelines/PipelineTypes';
import {getInputStepDatasRecord} from 'pipelines/StepDataUtils';

import {MAX_POPOVER_HEIGHT, MAX_POPOVER_WIDTH} from './PopoverConstants';

export default function TransformPopoverContents({step}: {step: PipelineStep}): JSX.Element {
  assert(stepIsConfigEditorSupported(step), 'Unsupported step for transform popover');
  assert(step.config != null, 'Expected non-null config');

  const inputDataFrames = getInputStepDatasRecord(step, PipelineStepDataKind.DATASET);

  return (
    <div className={css(styles.wrapper)}>
      <StepConfigEditorPane
        stepType={step.stepType}
        stepVersion={step.stepVersion}
        config={step.config}
        setConfig={noop}
        readOnly={true}
        inputDataFrames={inputDataFrames}
        clientStateId={step.id}
      />
    </div>
  );
}

const PADDING = 10;

const styles = StyleSheet.create({
  wrapper: {
    padding: PADDING,
    margin: PADDING,
    width: MAX_POPOVER_WIDTH - PADDING,
    maxHeight: MAX_POPOVER_HEIGHT,
  },
});
